import { api } from '@/lib/api/client';
import { unwrap } from '@/lib/api/envelope';
import { Endpoints } from '@/lib/api/endpoints';
import type { ResponseEnvelope } from '@/types/api';

export interface BillingSummary {
  balance: number;
  balanceExpiryDate: string | null;
  balanceValid: boolean;
  usedThisMonth: number;
  usedToday: number;
  averageDailyUsage: number;
}

export interface Invoice {
  id: string;
  periodStart: string;
  periodEnd: string;
  amountCents: number;
  currency: string;
  status: string;
  issuedAt: string;
}

export async function fetchBillingSummary(clientId?: string): Promise<BillingSummary> {
  const res = await api.get<ResponseEnvelope<BillingSummary>>(Endpoints.billing.summary, {
    params: clientId ? { clientId } : undefined,
  });
  return unwrap(res);
}

export async function fetchInvoices(clientId?: string): Promise<Invoice[]> {
  const res = await api.get<ResponseEnvelope<Invoice[]>>(Endpoints.billing.invoices, {
    params: clientId ? { clientId } : undefined,
  });
  return unwrap(res) ?? [];
}
